import React from "react";
import { AppIcon, AppIconProps } from "../Generic/AppIcon";
import { If } from "../Generic/If";

interface Props extends AppIconProps {
  badge: string | number;
}

const IconWithBadge = ({ badge, ...props }: Props) => {
  return (
    <div className="IconWithBadge">
      <AppIcon {...props} />
      <If condition={badge !== 0}>
        <span className="__badge">{badge}</span>
      </If>
    </div>
  );
};

export default React.memo(IconWithBadge);
